const actions = {
  GET_ACTIVE_AGENT: 'GET_ACTIVE_AGENT',
  GET_ACTIVE_AGENT_SUCCESS: 'GET_ACTIVE_AGENT_SUCCESS',
  GET_ACTIVE_AGENT_FAILED: 'GET_ACTIVE_AGENT_FAILED',
  GET_AGENT_TRANSACTIONS: 'GET_AGENT_TRANSACTIONS',
  GET_AGENT_TRANSACTIONS_SUCCESS: 'GET_AGENT_TRANSACTIONS_SUCCESS',
  GET_AGENT_TRANSACTIONS_FAILED: 'GET_AGENT_TRANSACTIONS_FAILED',
  GET_AGENT_TRANSACTIONS_DETAILS: 'GET_AGENT_TRANSACTIONS_DETAILS',
  GET_AGENT_TRANSACTIONS_DETAILS_SUCCESS: 'GET_AGENT_TRANSACTIONS_DETAILS_SUCCESS',
  GET_AGENT_TRANSACTIONS_DETAILS_FAILED: 'GET_AGENT_TRANSACTIONS_DETAILS_FAILED',

  getActiveAgent: (offset, limit, search, agentId) => ({
    type: actions.GET_ACTIVE_AGENT,
    payload: { offset, limit, search, agentId },
  }),
  getActiveAgentSuccess: (data, totalData) => ({
    type: actions.GET_ACTIVE_AGENT_SUCCESS,
    payload: { data, totalData },
  }),
  getActiveAgentFailed: (error) => ({
    type: actions.GET_ACTIVE_AGENT_FAILED,
    payload: { error },
  }),
  getAgentTransactions: ( offset, limit, fromDate, toDate) => ({
    type: actions.GET_AGENT_TRANSACTIONS,
    payload: { offset, limit, fromDate, toDate },
  }),
  getAgentTransactionsSuccess: (data, totalData) => ({
    type: actions.GET_AGENT_TRANSACTIONS_SUCCESS,
    payload: { data, totalData },
  }),
  getAgentTransactionsFailed: (error) => ({
    type: actions.GET_AGENT_TRANSACTIONS_FAILED,
    payload: { error },
  }),
  getAgentTransactionsDetails: ( agentId, fromDate, toDate) => ({
    type: actions.GET_AGENT_TRANSACTIONS_DETAILS,
    payload: { agentId, fromDate, toDate },
  }),
  getAgentTransactionsDetailsSuccess: (data) => ({
    type: actions.GET_AGENT_TRANSACTIONS_DETAILS_SUCCESS,
    payload: { data },
  }),
  getAgentTransactionsDetailsFailed: (error) => ({
    type: actions.GET_AGENT_TRANSACTIONS_DETAILS_FAILED,
    payload: { error },
  }),
};

export default actions;
